<template>
  <div
    v-loading.fullscreen.lock="isLoading"
    element-loading-text="กำลังโหลดข้อมูล..."
    class="user-load-info">
    <el-row class="reload-panel-holder" type="flex" justify="left" align="middle">
      <el-col :span="24">
        <div class="reload-panel" v-if="shouldReloadData && !isLoading">
          <h3>ระบบไม่สามารถโหลดข้อมูลของบริษัทได้<br/>กรุณาลองใหม่อีกครั้ง</h3>
          <el-button type="primary" icon="el-icon-refresh" @click="reloadInfo">โหลดข้อมูลใหม่</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import companyService from '@/services/company';

  const AdminLoadInfo = {
    name: 'admin-load-info',
    data() {
      return {
        isLoading: false,
      };
    },
    computed: {
      shouldReloadData() {
        return !(this.$store.getters.scbAdminInfo);
      },
      idToken() {
        return this.$store.getters.idToken;
      },
    },
    methods: {
      reloadInfo() {
        this.isLoading = true;
        // now we get the user info first
        this.$store.dispatch('GET_ADMIN_MY_ADMIN_INFO').then(() => {
          this.$router.push({ name: 'CompanyList' });
        }).catch((err) => {
          this.isLoading = false;
          if (err) {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t(err));
          } else {
            this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
          }
        });
      },
    },
    mounted() {
      if (this.idToken) {
        companyService.setJWTToken(this.$store.getters.idToken);
        this.reloadInfo();
      }
    },
    watch: {
      idToken(newVal) {
        if (newVal) {
          companyService.setJWTToken(this.$store.getters.idToken);
          this.reloadInfo();
        }
      },
    },
  };
  export default AdminLoadInfo;
</script>

<style lang="scss">
  .user-load-info{
    height: 100%;
    .reload-panel-holder {
      height: 100%;
    }
    .reload-panel{
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/company/admin-load-info.vue